import { User, Scale, Clipboard, Calendar, Receipt } from "lucide-react";
import PropTypes from "prop-types";
import { cpf } from "../../../utils/formats";
import formatDateSolicitation from "../../../utils/formatDateSolicitation";
import { useMemo } from "react";

const PatientCard = ({
  patient,
  onViewProcedures,
  onViewScheduledProcedures,
  onMakePayment,
  onViewBudget
}) => {

  const stats = useMemo(() => {
    const allProcedures = Object.values(patient.procedures_by_date || {})
      .flatMap(dateObj => Object.values(dateObj).flat());

    const agendados = allProcedures.filter(p => p.scheduled).length;
    const naoAgendados = allProcedures.filter(p => !p.scheduled).length; // ou patient.procedures.length conforme original
    const pagos = Array.isArray(patient.payment_status?.paid) ? patient.payment_status.paid.length : 0;

    const user = allProcedures.filter(p => p.scheduled)[0]?.user_name || '';

    return { agendados, naoAgendados, pagos, user };
  }, [patient]);

  return (
    <div className="patient-card">
      <div className="patient-avatar">
        <User size={32} />
      </div>

      <div className="patient-info">
        <div className="patient-main-info align-items-center">
          <div className="patient-name-container">
            <h3 className="patient-name">{patient.name}</h3>
            <p className="patient-cpf">CPF: {cpf(patient.cpf)}</p>
            <p className="fw-semibold fs-6">
              {formatDateSolicitation(patient.patient.date_solicitation)[0]} - {formatDateSolicitation(patient.patient.date_solicitation)[1]}
            </p>
          </div>
        </div>
      </div>

      <div className="patient-procedures">
        <p className="d-flex flex-column gap-1">
          <span style={{ color: "green", display: "flex", fontWeight: "bold", alignItems: "center", fontSize: "12px" }}>
            <Calendar size={16} style={{ marginRight: "0.5rem" }} />
            Agendados: {stats.agendados}
          </span>
          
          <span style={{ color: "blue", display: "flex", fontWeight: "bold", alignItems: "center", fontSize: "12px" }}>
            <Calendar size={16} style={{ marginRight: "0.5rem" }} />
            Não agendados: {patient.procedures.length}
          </span>

          <span style={{ color: "orange", display: "flex", fontWeight: "bold", alignItems: "center", fontSize: "12px" }}>
            <Receipt size={16} style={{ marginRight: "0.5rem" }} />
            Pagos: {stats.pagos}
          </span>

          {
            stats.user && (
              <span className="mt-3" style={{ fontSize: '12px'}}>
                <User size={16} /> {stats.user}
              </span>
            )
          }

        </p>
      </div>

      <div className="patient-actions">
        <button
          className="budget-button"
          onClick={onViewBudget}
          aria-label="Montar orçamento"
          disabled={patient.pending.length === 0}>
          <Scale size={20} />
          <span>Orçamento</span>
        </button>

        <button
          className="procedure-button"
          onClick={onViewProcedures}
          aria-label="Ver procedimentos disponíveis">
          <Clipboard size={20} />
          <span>Procedimentos</span>
        </button>

        <button
          className="scheduled-button"
          onClick={onViewScheduledProcedures}
          aria-label="Ver procedimentos agendados">
          <Calendar size={20} />
          <span>Agendados</span>
        </button>

        <button
          className="payment-card-button"
          onClick={onMakePayment}
          aria-label="Realizar pagamento">
          <Receipt size={20} />
          <span>Pagamento</span>
        </button>
      </div>
    </div>
  );
};

PatientCard.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    cpf: PropTypes.string.isRequired,
    procedures: PropTypes.array.isRequired,
    scheduled: PropTypes.bool,
  }).isRequired,
  onViewDetails: PropTypes.func.isRequired,
  onViewProcedures: PropTypes.func.isRequired,
  onViewScheduledProcedures: PropTypes.func.isRequired,
  onMakePayment: PropTypes.func.isRequired,
};

export default PatientCard;
